import makeStyles from '@mui/styles/makeStyles';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {user} from '../../../store/reducers/user';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import AgyleDialog from '../../../components/modal/agyleDialog';
import {useTranslation} from 'react-i18next';
import Formatter from '../../../util/formatter';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Notes from '../../../util/notes';
import {FormControl, MenuItem, Select} from '@mui/material';
import InformationBox from '../../../components/other/informationBox';
import {
    Glass10Icon,
    Glass11Icon,
    Glass12Icon,
    Glass1Icon,
    Glass2Icon,
    Glass3Icon,
    Glass4Icon,
    Glass5Icon,
    Glass6Icon,
    Glass7Icon,
    Glass8Icon,
    Glass9Icon,
} from '../../../components/icons/icons';
import * as _set from 'lodash/set';
import _ from 'lodash';
import {useTheme} from '@mui/material/styles';
import {formAuditIsValid} from '../forms/formsUtil';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background + ` !important`,
    },
    drinkLabel: {
        maxWidth: 100,
        fontSize: 14,
        textAlign: 'center',
        fontWeight: 400,
    },
    drinkIcon: {
        fontSize: 110,
    },
    outcome: {
        border: '1px solid #7199E6',
        background: '#cfdffd',
        color: '#3F73D6',
        display: 'flex',
        padding: 10,
        justifyContent: 'center',
        gap: 15,

    },
    auditImg: {
        width: '100%', maxWidth: 700,
    },
    scores: {
        fontSize: '15px',
        textAlign: 'right',
        fontWeight: 'bold',
        background: '#4EAC6F',
        width: 'max-content',
        padding: '10px',
        borderRadius: '10px',
        color: 'black',
    },
    outcomeLabel: {
        fontWeight: 'bold',
        fontSize: 15,
        color: '#3F73D6',
    },
    groupRoot: {
        marginBottom: 10,
        padding: 5,
        borderRadius: 5,
    },
    paper: {
        padding: 10,
        backgroundColor: '#252525',
    },
    centerRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    userLog: {
        fontSize: 11,
        fontStyle: 'italic',
        color: theme.palette.mode === 'light' ? '#4B4B4B' : '#818181',
    },
    comment: {
        fontSize: 15,
        padding: 5,
        backgroundColor: theme.palette.background.default,
        borderRadius: 5,
    },
    clinician: {
        marginBottom: 10,
    },
    row: {
        width: '100%',
        marginBottom: 10,
    },
    divider: {
        margin: '10px 0',
    },
    label: {
        color: theme.palette.inPatient.questionText,
        fontSize: 12,
        fontWeight: 600,
        marginLeft: 5,
        marginBottom: 5,
    },
    dropDownIcon: {
        borderRadius: 10,
        backgroundColor: theme.palette.inPatient.inputBackground,
    },
    switchLabel: {
        fontSize: 14,
        fontWeight: 600,
        paddingLeft: 10,
    },
    iconDrink: {
        stoke: theme.palette.text,
    },
}));

export function AuditCForm(props) {
    const classes = useStyles();
    const {t} = useTranslation();

    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);

    let questions = {
        howOftenDrinkAlcohol: {
            text: 'How Often Do You Have a Drink Containing Alcohol?',
            tab: 'A',
        },
        standardDrinkDay: {
            text: 'How Many Standard Drinks Containing Alcohol Do You Have on a Typical Day?',
            tab: 'B',
        },
        howOftenMoreDrink: {
            text: 'How Often Do You Have 6 or More Drinks on One Occasion?',
            tab: 'C',
        },

        notAbleToStopDrinking: {
            text: 'How often during the last year have you found that you were not able to stop drinking once you had started?',
            tab: 'C',
        },
        failedBecauseDrinking: {
            text: 'How often during the last year have you failed to do what was normally expected from you because of your drinking?',
            tab: 'C',
        },
        neededAlcoholicMorning: {
            text: 'How often during the last year have you needed an alcoholic drink in the morning to get yourself going after a heavy drinking session?',
            tab: 'C',
        },
        unableRememberWhatHappened: {
            text: 'How often during the last year have you been unable to remember what happened the night before because you had been drinking?',
            tab: 'C',
        },
        injuredResultDrinking: {
            text: 'Have you or somebody else been injured as a result of your drinking?',
            tab: 'D',
        },
        relativeConcerned: {
            text: 'Has a relative or friend, doctor or other health worker been concerned about your drinking or suggested that you cut down?',
            tab: 'D',
        },
    };

    let smokingFormInit = {
        base: {
            howOftenDrinkAlcohol: '',
            standardDrinkDay: '',
            howOftenMoreDrink: '',
        },
        extra: {
            notAbleToStopDrinking: '',
            failedBecauseDrinking: '',
            neededAlcoholicMorning: '',
            unableRememberWhatHappened: '',
            injuredResultDrinking: '',
            relativeConcerned: '',
        },

        who: '',
        date: '',
    };

    let tabs = {
        B: [
            {
                text: '0',
                value: 0,
            },
            {
                text: '1 or 2',
                value: 0,
            },
            {
                text: '3 or 4',
                value: 1,
            },
            {
                text: '5 or 6',
                value: 2,
            },
            {
                text: '7 to 9',
                value: 3,
            },
            {
                text: '10 or more',
                value: 4,
            },
        ],
        A: [
            {
                text: 'never',
                value: 0,
            },
            {
                text: 'monthly or less',
                value: 1,
            },
            {
                text: '2-4 times a month',
                value: 2,
            },
            {
                text: '2-3 times a week',
                value: 3,
            },
            {
                text: '4 or more times a week',
                value: 4,
            },
        ],
        C: [
            {
                text: 'never',
                value: 0,
            },
            {
                text: 'less than monthly',
                value: 1,
            },
            {
                text: 'monthly',
                value: 2,
            },
            {
                text: 'weekly',
                value: 3,
            },
            {
                text: 'daily or almost daily',
                value: 4,
            },
        ],
        D: [
            {
                text: 'no',
                value: 0,
            },
            {
                text: 'yes, but not in the last year',
                value: 1,
            },
            {
                text: 'yes, during last year',
                value: 2,
            },
        ],
    };

    useEffect(() => {
        setForm((formLast) => {
            return {
                ...formLast,
                who: tester,
                date: moment().toISOString(),
            };
        });
    }, [userObject]);

    const [form, setForm] = useState(smokingFormInit);

    useEffect(() => {
        if (props.auditC) {
            let cloneForm = _.cloneDeep(props.auditC);
            setForm({
                ...cloneForm,
                who: tester,
                date: moment().toISOString(),
            });
        }

    }, []);

    useEffect(() => {
        if (props.changeFormData) {
            props.changeFormData(form);
        }
        if (props.formIsValid) {
            props.formIsValid(formAuditIsValid(form));
        }
    }, [form]);


    const getMenuItem = (tab) => {
        let items = [];

        items.push(
            <MenuItem key={'notselect'} value={''}>
                <em>Not selected</em>
            </MenuItem>,
        );
        tab.forEach((item, index) => {
            items.push(<MenuItem key={index} value={tab[index]}> {tab[index].text} </MenuItem>);
        });

        return items;
    };

    const onPropChange = (prop) => {
        return (event, value) => {
            const data = {...form};
            _set(data, prop, event.target.value);

            if (props.formIsChanged) props.formIsChanged(true);
            setForm(data);
        };
    };


    const getDrinkQuestions = (type) => {
        let items = [];

        Object.keys(form[type]).forEach((field, index) => {
            items.push(
                <Grid item xs={12} key={index + 'text'}>
                    <div className={classes.label}> {questions[field].text}</div>
                    <FormControl className={classes.selectorItemFormControl} fullWidth>
                        <Select
                            className={classes.dropDownIcon}
                            labelId="label-howOftenMoreDrink"
                            id={field}
                            variant="outlined"
                            name={type + '.' + field}
                            renderValue={(selected) => {
                                return selected.text;
                            }}
                            value={form[type][field]}
                            error={form[type][field] === ''}
                            onChange={onPropChange(type + '.' + field)}
                        >
                            {getMenuItem(tabs[questions[field].tab])}
                        </Select>
                    </FormControl>
                </Grid>,
            );
        });

        return items;
    };

    const getScoreDrink = () => {
        let score = 0;
        Object.keys(form.base).forEach((key) => {
            if (form.base[key]) {
                score += form.base[key].value;
            }
        });

        if (score <= 4)
            removeAuditCFields();

        return score;
    };

    const getScoreTotalDrink = () => {
        let score = 0;
        Object.keys(form.extra).forEach((key) => {
            if (form.extra[key])
                score += form.extra[key].value;
        });
        Object.keys(form.base).forEach((key) => {
            if (form.base[key])
                score += form.base[key].value;
        });

        return score;
    };

    const removeAuditCFields = () => {
        const data = {...form};
        let someChange = false;
        Object.keys(data.extra).forEach((key) => {
            if (data.extra[key]) {
                data.extra[key] = '';
                someChange = true;
            }
        });

        _set(data, 'extra', data.extra);
        if (someChange) setForm(data);
    };

    const theme = useTheme();
    return (
        <Grid container spacing={2} alignItems={'center'}>
            <Grid item xs={12}>
                <InformationBox type="info" label={'Information'}>
                    {t('Audit C is scored on a scale of 0-12 with scores of 0 reflecting no alcohol use. In men, a score of 4 or more is considered positive and in women, a score of 3 or more is considered positive. Generally, the higher the Audit C score, the more likely it is that the patient\'s drinking is affecting his/her health and safety.')}
                </InformationBox>
            </Grid>

            <Grid item xs={12}>
                <InformationBox type="info" label={'The Following Drinks Are One Unit Of Alcohol'}>
                    <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'baseline'}}>
                        <div style={{textAlign: 'center'}}>
                            <Glass1Icon style={{fontSize: 110, stroke: theme.palette.inPatient.text}}/>
                            <div className={classes.drinkLabel}> {t('Half pint of regular beer, lager or cider')} </div>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <Glass2Icon style={{fontSize: 100, stroke: theme.palette.inPatient.text}}/>
                            <div className={classes.drinkLabel}> {t('1 small glass of wine')} </div>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <Glass3Icon style={{fontSize: 80, stroke: theme.palette.inPatient.text}}/>
                            <div className={classes.drinkLabel}> {t('1 single measure of spirits')} </div>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <Glass4Icon style={{fontSize: 100, stroke: theme.palette.inPatient.text}}/>
                            <div className={classes.drinkLabel}> {t('1 small glass of sherry')} </div>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <Glass5Icon style={{fontSize: 100, stroke: theme.palette.inPatient.text}}/>
                            <div className={classes.drinkLabel}> {t('1 single measure of aperitifs')} </div>
                        </div>
                    </div>
                </InformationBox>
            </Grid>

            <Grid item xs={12}>
                <InformationBox type="info" label={'Each of these drinks is MORE than one unit'}>
                    <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'baseline'}}>
                        <div style={{textAlign: 'center'}}>
                            <Glass6Icon style={{fontSize: 80}}/>
                            <div className={classes.drinkLabel}> {t('Pint of regular beer, lager or cider')} </div>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <Glass7Icon style={{fontSize: 80}}/>
                            <div className={classes.drinkLabel}> {t('Pint of Premium Beer/Lager/Cider')} </div>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <Glass8Icon style={{fontSize: 110}}/>
                            <div className={classes.drinkLabel}> {t('Alcohol or can/bottle of Regular Lager')} </div>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <Glass9Icon style={{fontSize: 80}}/>
                            <div className={classes.drinkLabel}> {t('Can of Super Strength Lager')} </div>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <Glass10Icon style={{fontSize: 80}}/>
                            <div className={classes.drinkLabel}> {t('Half pint of regular beer, lager or cider')} </div>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <Glass11Icon style={{fontSize: 70}}/>
                            <div className={classes.drinkLabel}> {t('Glass of Wine (175ml)')} </div>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <Glass12Icon style={{fontSize: 110}}/>
                            <div className={classes.drinkLabel}> {t('Bottle of Wine')} </div>
                        </div>
                    </div>
                </InformationBox>
            </Grid>

            {getDrinkQuestions('base')}

            <Grid item xs={12}>
                <div className={classes.scores}>
                    {t('SCORE OF')}: {getScoreDrink()}
                </div>
            </Grid>

            {getScoreDrink() > 4 &&
                getDrinkQuestions('extra')
            }

            {getScoreDrink() > 4 &&
                <Grid item xs={12}>
                    <div className={classes.scores}>
                        TOTAL SCORE OF: {getScoreTotalDrink()}
                    </div>
                </Grid>
            }
        </Grid>
    );
}

function AuditCFormModal(props) {
    const classes = useStyles();
    const {t} = useTranslation();

    const [formData, setFormData] = useState(null);

    const handleSubmit = () => {
        if (props.onSave) {
            props.onSave(
                [
                    {
                        name: 'auditC',
                        value: formData,
                        noteToAdd: Notes.getAuditCNote(formData),
                    },
                ],
            );
        }

        if (props.onClose) props.onClose();
    };

    const removeOxygen = () => {
        if (props.onSave) {
            props.onSave(
                [
                    {
                        name: 'auditC',
                        value: null,
                        noteToAdd: Notes.getAuditCNote(null),
                    },
                ],
            );
        }

        if (props.onClose) props.onClose();
    };

    return (
        <AgyleDialog
            open
            onClose={props.onClose}
            title={t('Audit C')}
            disableSubmit={props.disableSave}
            onSave={handleSubmit}
            fullWidth
            width="md"
            closeButtonOnHeader
            buttons={[
                <AgyleButton
                    disabled={props.disableSave}
                    onClick={removeOxygen}
                >
                    {'Delete'}
                </AgyleButton>,
            ]}
            contentStyle={classes.root}
            titleStyle={classes.root}
        >
            <AuditCForm
                auditC={props.currentPatientInWard?.auditC}
                changeFormData={setFormData}
            />
        </AgyleDialog>
    );
}

export default AuditCFormModal;